import { useLanguageContext } from "../../../../../../context/LanguageContext";
import LabelItemParagraph from "../../paragraph/ParagraphLabelItem";

export default function FieldLabelLabelItem({ item, printerData, fields }) {
  const { translateEntity } = useLanguageContext();
  let field = item.field || item.field_id;
  if (!(field instanceof Object)) {
    field = fields?.find((f) => f.id === field) ?? null;
  }

  return (
    field && (
      <LabelItemParagraph item={item} printerData={printerData}>
        {translateEntity(field, "label") + ":"}
      </LabelItemParagraph>
    )
  );
}
